/**
 * Whether a claim's workflow locks its partner, read from the claim detail
 * payload's `partner_lock` block (backed by `partner_locked` on the workflow
 * metadata - see `apps/claims/services/partner_lock.py`).
 *
 * The holding action keys to leave out come from the backend too, so this
 * module holds no action-key list of its own. The payload is a JSON blob, so
 * the shape is checked rather than assumed: anything malformed reads as
 * unlocked, which is today's behaviour.
 */

export interface PartnerLock {
  locked: boolean
  /** Holding entity actions that would change the partner. */
  hidden_holding_action_keys: string[]
}

const UNLOCKED: PartnerLock = { locked: false, hidden_holding_action_keys: [] }

export function resolvePartnerLock(raw: unknown): PartnerLock {
  if (!raw || typeof raw !== 'object') return UNLOCKED
  const value = raw as Record<string, unknown>
  if (value.locked !== true) return UNLOCKED
  const keys = Array.isArray(value.hidden_holding_action_keys)
    ? value.hidden_holding_action_keys.filter(
        (k): k is string => typeof k === 'string' && k.length > 0,
      )
    : []
  return { locked: true, hidden_holding_action_keys: keys }
}
